export default "__VITE_ASSET__DSjsf0gj__"